export default __webpack_public_path__ + "static/media/c_mobile_dr_00.a1cc0215.png";